module.exports = __webpack_public_path__ + "static/media/na-logo-dashboard.94057436.svg";